export const activity = {
  screenTitle: 'Activity',
  badgeContractor: 'Contractor Workspace',
  segmentInbox: "Notifications",
  segmentFeed: 'Workspace activity',
  notifications: 'Notifications',
  notificationFallback: 'Notification',
  recentUpdates: 'Recent updates',
  fullFeed: 'Full feed',
  pendingApproval: 'Needs your response',
  reviewRequired: 'Review required',
  inspectionReportMeta: 'Inspection report',
  viewAsset: 'View asset',
  approvedForRepair: 'Approved for repair',
  repairsApproved_one: '{{count}} repair approved',
  repairsApproved_other: '{{count}} repairs approved',
  createJobs: 'Create jobs',
  awaitingRecipient: 'Waiting on recipient',
  firstShared: 'First shared {{date}}',
  resent: 'Resent {{date}}',
  waitingForReview: 'Waiting for review',
  resendDeadline: 'Resend & update deadline',
  jobInvitations: 'Job invitations',
  jobFallbackTitle: 'Job #{{id}}',
  acceptOrDecline: 'Accept or decline',
  accept: 'Accept',
  decline: 'Decline',
  reportsSharedWithYou: 'Reports shared with you',
  inspectionReportCard: 'Inspection report',
  emptyInboxTitle: 'Nothing needs you',
  emptyInboxSub: 'Approvals, invitations, and replies waiting on you show up here.',
  feedTitle: 'Activity feed',
  emptyFeedTitle: 'No team activity yet',
  emptyFeedSub: 'Job assignments, status changes, and approvals across the team show up here.',
  events: {
    inspectionSentBack: "Inspection sent back",
    jobAssigned: 'Job assigned',
    jobAssignedTo: 'Job assigned to {{name}}',
    jobAccepted: 'Job accepted',
    jobRejected: 'Job rejected',
    jobRejectedBy: 'Job rejected by {{name}}',
    jobStarted: 'Job started',
    jobScheduled: "Job scheduled",
    jobReportShared: "Job report shared",
    teamMemberJoined: "Joined the team",
    jobPaused: 'Job paused',
    jobResumed: 'Job resumed',
    completionSubmitted: 'Completion submitted',
    jobVerified: 'Job verified',
    reworkRequested: 'Rework requested',
    reworkRequestedBy: 'Rework requested by {{name}}',
    evidenceRequested: "More evidence requested",
    evidenceRequestedBy: "More evidence requested by {{name}}",
    jobStatusChanged: 'Job {{status}}',
    jobUpdatedFallback: 'updated',
    contractorInvited: 'Contractor invited to job',
    contractorAccepted: 'Contractor accepted job',
    contractorDeclined: 'Contractor declined job',
    quoteRequestSent: 'Quote request sent',
    quoteSubmitted: 'Quote submitted',
    quoteAccepted: 'Quote accepted',
    quoteRejected: 'Quote rejected',
    quoteDeclined: 'Quote request declined',
    contractorAwarded: 'Contractor awarded',
    inspectionShared: 'Inspection shared',
    inspectionCompleted: 'Inspection completed',
    inspectionApproved: 'Inspection approved',
    requestCreated: 'Request raised',
    requestApproved: 'Request approved',
    requestDeclined: 'Request declined',
    requestConverted: 'Request turned into work',
    requestClosed: 'Request closed',
    assetDecommissioned: 'Asset taken out of service',
    assetRetired: 'Asset retired',
    connectedAlert: "Device alert",
    assetCreated: 'Asset added',
    assetUpdated: 'Asset updated',
    assetDeleted: 'Asset deleted',
    assetInService: 'Asset back in service',
    contactAdded: 'Contact added',
    contactSharedTeam: 'Contact shared with team',
    contactPromoted: 'Contact promoted to account',
    contactInvited: 'Contact invited',
    contactLinked: 'Contact linked',
    assetRelAdded: 'Asset relationship added',
    assetRelUpdated: 'Asset relationship updated',
    assetRelRemoved: 'Asset relationship removed',
    duplicateMarked: 'Duplicate asset marked',
    canonicalSet: 'Canonical asset set',
    duplicatesMerged: 'Duplicate assets merged',
    approvalWithAsset: 'Inspection for {{asset}} approved by {{recipient}}',
    approvalByRecipient: 'Inspection report approved by {{recipient}}',
    approvalGeneric: 'Inspection report approved',
    rejectionWithAsset: 'Inspection for {{asset}} rejected by {{recipient}}',
    rejectionByRecipient: 'Inspection report rejected by {{recipient}}',
    rejectionGeneric: 'Inspection report rejected',
  },
  jobStatus: {
    draft: 'Draft',
    open: 'Open',
    accepted: 'Accepted',
    scheduled: 'Scheduled',
    inProgress: 'In progress',
    paused: 'Paused',
    completed: 'Completed',
    verified: 'Verified',
    rejected: 'Rejected',
    cancelled: 'Cancelled',
  },
  insights: {
    kpiName: {
      portfolio_condition: "Overall condition",
      assets_good_condition: "Assets in good condition",
      inspection_pass_rate: "Inspections passed",
      first_time_fix: "Fixed first time",
      backlog_weeks: "Work waiting (weeks)",
      mttr: "Average time to fix",
      maintenance_approval_turnaround: "Time to approve",
      maintenance_reassignment_rate: "Work handed to someone else",
      maintenance_reschedule_rate: "Maintenance moved",
      maintenance_missed_rate: "Maintenance missed",
      maintenance_skip_rate: "Maintenance skipped",
      on_time_completion: "Finished on time",
      reactive_vs_planned: "Unplanned work",
      pm_schedule_compliance: "Planned maintenance on time",
      cert_currency: "Certificates in date",
      statutory_compliance: "Legal compliance",
    },
    kpiTarget: "Target {{target}}",
    headlineKpi: {
      health: "Health",
      riskLevel: "Risk level",
      atRisk: "Assets at risk",
      outOfService: "Out of service",
      onTime: "On-time",
      compliance: "Compliance",
      ofTotal: "of {{total}}",
      noCompletedJobsWithDueDates: "no completed jobs with due dates",
      nothingToProveYet: "nothing to prove yet",
      registerNotLoaded: "compliance register not loaded",
    },
    kpiDetail: {
      requirementsCompliant_one: "{{compliant}} of {{count}} requirement compliant",
      requirementsCompliant_other: "{{compliant}} of {{count}} requirements compliant",
      certsCurrent: "{{valid}} of {{total}} current",
      onSchedule: "{{completed}} of {{total}} on schedule",
      jobsReactive_one: "{{reactive}} of {{count}} job reactive",
      jobsReactive_other: "{{reactive}} of {{count}} jobs reactive",
      onTime: "{{onTime}} of {{total}} on time",
      plannedOccurrences_one: "{{done}} of {{count}} planned occurrence",
      plannedOccurrences_other: "{{done}} of {{count}} planned occurrences",
      pastDueNoDecision: "{{missed}} of {{total}} past due with no decision",
      movedWithDelay_one: "{{moved}} of {{total}}, {{count}}d average delay",
      movedWithDelay_other: "{{moved}} of {{total}}, {{count}}d average delay",
      moved: "{{moved}} of {{total}} moved",
      decidedWaiting: "{{decided}} decided, {{pending}} waiting",
      decided: "{{decided}} decided",
      completedJobs_one: "{{count}} completed job",
      completedJobs_other: "{{count}} completed jobs",
      noOpenJobs: "No open jobs",
      noRecentCompletions: "No recent completions to project velocity",
      openPerWeek: "{{open}} open · {{rate}}/wk",
      reopenedOf: "{{reopened}} reopened of {{total}}",
      itemsOf_one: "{{pass}} of {{count}} item",
      itemsOf_other: "{{pass}} of {{count}} items",
      postureCounts: "{{clear}} good · {{watch}} watch · {{action}} action",
      atRiskOf: "{{atRisk}} of {{total}} at risk",
    },
    kpiUnit: {
      days: "{{value}}d",
      weeks: "{{value}} wk",
    },
    kpiTargetValue: {
      reactive: "≤ 20% reactive",
      oneDay: "≤ 1d",
      trendDown: "trend down",
      trendUp: "trend up",
      underFourWeeks: "< 4 weeks",
      rework: "rework ≤ 5%",
    },
    forecast: {
      certificatesLapse_one: "{{count}} certificate lapses within {{days}} days",
      certificatesLapse_other: "{{count}} certificates lapse within {{days}} days",
      moreSuffix_one: "+{{count}} more",
      moreSuffix_other: "+{{count}} more",
      backlogStalled_one: "Backlog of {{count}} job is not being cleared",
      backlogStalled_other: "Backlog of {{count}} jobs is not being cleared",
      backlogStalledDetail: "No jobs were completed in the last 4 weeks — backlog will keep growing without action.",
      backlogGrowing: "Backlog projected to grow to ~{{projected}} in 4 weeks",
      backlogGrowingDetail: "Arriving {{inflow}}/wk vs clearing {{velocity}}/wk — capacity is below demand.",
      backlogBurndown: "Backlog clears in ~{{weeks}} weeks at current pace",
      backlogBurndownDetail: "{{open}} open · clearing {{velocity}}/wk vs {{inflow}}/wk arriving.",
      declineTitle: "{{name}} likely to fall to Action soon",
      declineDetailDocument: "Currently Watch ({{score}}/100); {{regulation}} lapses within 30 days.",
      declineDetailSchedule: "Currently Watch ({{score}}/100) with a due/overdue scheduled inspection.",
    },
    sections: {
      a11y: "Insights sections",
      workflows: "Workflows",
      overview: "Overview",
    },
    chart: {
      emptyReason: {
        noRecords: 'No records available',
        noQualifyingRecords: 'No qualifying records',
        filteredEmpty: 'No matches for these filters',
        insufficientSample: 'Not enough evidence yet',
        notApplicable: 'Not applicable',
        loadFailed: 'Could not load chart data',
        stale: 'Data needs refreshing',
      },
      defaultAccessibilityLabel: 'Chart',
    },
    shell: {
      hideDetails: 'Hide insight details',
      showDetailsSuffix: 'Show insight details.',
      expandHint: 'Double tap to expand the full insight panel',
    },
    conditionPortfolio: {
      stableCount_one: "{{count}} stable.",
      stableCount_other: "{{count}} stable.",
      band: {
        critical: 'Critical',
        action_recommended: 'Action recommended',
        deteriorating: 'Deteriorating',
        watch: 'Watch',
        stable: 'Stable',
      },
      bandInfo: {
        critical: 'Assets whose evidence says they need attention now: failed safety items, overdue urgent work or a fast decline.',
        action_recommended: 'Assets heading the wrong way where planned action is advised before they become critical.',
        deteriorating: 'Assets whose inspections, repairs or maintenance history show a steady decline.',
        watch: 'Assets with an early warning sign worth watching, not yet a decline.',
      },
      noDominantDriver: 'No single driver stands out.',
      recurringFault_one: '{{count}} asset with a recurring fault',
      recurringFault_other: '{{count}} assets with a recurring fault',
      repeatRepairs: '{{count}} with repeat repairs',
      noExceptions: 'No recurring faults or repeat repairs across the portfolio.',
      noteSuffix: 'Meter signals are shown on each asset, not here.',
      moreOnList: '+{{count}} more on the asset list.',
      wholeCountsNote: "Counts cover every asset, as of {{date}}. The assets listed are examples from those loaded.",
    },
    panel: {
      basedOn: 'Based on: {{source}}',
      severityHighPriority: 'High priority',
      severityAttention: 'Attention',
      severityOnTrack: 'On track',
      severityFyi: 'FYI',
      severityNote: 'Note',
      moreItems: '+{{count}} more here — refine or search to narrow.',
      signalsTitle: 'Signals',
      recommendedActionTitle: 'Recommended action',
    },
    kpiInfo: {
      aboutLabel: 'About {{label}}',
      hint: 'Opens an explanation of this metric and how to use it',
    },
    metricInfoSheet: {
      dismissOverlay: 'Dismiss',
      close: 'Close',
      whatItMeasures: 'WHAT IT MEASURES',
      howToUseIt: 'HOW TO USE IT',
      basedOn: 'BASED ON',
      asOf: 'As of · {{value}}',
      target: 'Target · {{value}}',
    },
    priorityCard: {
      feedbackHelpful: 'Helpful',
      feedbackNotUseful: 'Not useful',
      feedbackSnooze: 'Snooze',
      feedbackDismiss: 'Dismiss',
      recommended: 'Recommended: {{action}}.',
      effort: 'Effort: {{value}}',
      expectedBenefit: 'Expected benefit: {{value}}',
      dataGaps: 'Data gaps',
      butAlso: 'But also',
      feedbackTrigger: 'Insight feedback',
      feedbackSheetTitle: 'Was this useful?',
    },
    journeys: {
      tabExecutive: 'Executive',
      tabRequest: 'Request',
      tabInspection: 'Inspection',
      tabJob: 'Job',
      tabAsset: 'Asset',
      tabContractor: 'Contractor',
      tabCompliance: 'Compliance',
      tablistLabel: 'Journey dashboards',
      executiveAssistantTitle: 'Executive assistant',
      pageTitle: 'Journey analytics',
      journeyCount_one: '{{count}} journey',
      journeyCount_other: '{{count}} journeys',
      requestFunnel: 'Request funnel',
      journeyFunnel: 'Journey funnel',
      stageFlow: 'Stage flow',
      noJourneyFlow: 'No journey flow yet.',
      durationDistribution: 'Journey duration distribution',
      noCompletedJourneys: 'No completed journeys yet.',
      bottlenecksMedianGap: 'Bottlenecks (median stage gap)',
      bottleneckEmpty:
        'Nothing measured yet. A bottleneck needs at least one journey that has completed two consecutive steps (for example request → approval).',
      workFunnel: 'Work funnel',
      bottleneckRanking: 'Bottleneck ranking',
      recentJourneyActivity: 'Recent journey activity',
      noRecentEvents: 'No recent events.',
      slaComplianceByStage: 'SLA compliance by stage',
      slaEmpty:
        'Nothing measured yet. This fills in once a request is approved, an inspection leads to a job, or a job is started or completed — the gaps between those steps are what SLA compliance measures.',
      bottlenecks: 'Bottlenecks',
      whatNeedsAttention: 'What needs attention',
    },
    screen: {
      aiSummaryButton: "Write an AI summary",
      emptyStartInspection: "Start an inspection",
      emptyAddAsset: "Add an asset",
      scopeAllMultiTeam: "Everyone's work — best for comparing teams side by side.",
      scopeAllSingleTeam: 'All the work in your account.',
      scopePersonalMultiTeam: 'Just your work. Switch to All to see the whole team.',
      scopePersonalSingleTeam: 'Just your work.',
      scopeTeamMultiTeam: 'Only {{team}} is included. Switch scope to All to compare teams side by side.',
      scopeTeamSingleTeam: 'Only {{team}} is included.',
      greetingLate: 'Working late',
      greetingMorning: 'Good morning',
      greetingAfternoon: 'Good afternoon',
      greetingEvening: 'Good evening',
      greetingNoPriorities: 'No priorities today. Trends below as data builds up.',
      greetingDanger_one: '{{count}} issue needs attention today — top item is high risk.',
      greetingDanger_other: '{{count}} issues need attention today — top item is high risk.',
      greetingTechnician_one: "You have {{count}} thing to do. Start with the top card.",
      greetingTechnician_other: "You have {{count}} things to do. Start with the top card.",
      greetingExecutive_one: "{{count}} item is worth a look, most costly first.",
      greetingExecutive_other: "{{count}} items are worth a look, most costly first.",
      greetingTeam_one: '{{count}} priority for the team today.',
      greetingTeam_other: '{{count}} priorities for the team today.',
      loadingTitle: 'Loading Insights',
      emptyGetsUsefulTitle: 'Insights gets useful with usage',
      emptyGetsUsefulDescription: "Add an asset or start an inspection. Insights then shows what needs attention and what is slipping.",
      partialDataCaption: 'These charts use loaded records. Portfolio totals may be incomplete.',
      partialDataCaptionConditionWhole: 'Health, risk level, at risk and out of service cover every asset. The other figures and charts use loaded records and may be incomplete.',
      partialDataCaptionConditionBandsWhole: "Health, risk level, at risk, out of service, the condition bands and assets in good condition cover every asset. The other figures and charts use loaded records and may be incomplete.",
      refreshErrorTitle: 'Some Insights data could not be refreshed',
      refreshErrorDescription:
        'The charts below use cached records and may be incomplete. Try again when your connection is available.',
      roleTechnician: 'Technician',
      roleManager: 'Manager',
      roleExecutive: 'Executive',
      switchToRoleView: 'Switch to {{role}} view',
      resetToAutoLabel: 'Reset to auto-detected view',
      resetToAutoText: 'Reset to auto',
      showingLabel: 'Showing',
      clearSiteFilter: 'Clear site filter',
      allSites: 'All sites',
      unassignedSite: 'Unassigned',
      selectedSiteFallback: 'Selected site',
      standardsEyebrow: 'Standards',
      operationalKpisTitle: 'Operational KPIs',
      subtitleNeedAttention_one: '{{count}} needs attention · {{onTrack}} on target',
      subtitleNeedAttention_other: '{{count}} need attention · {{onTrack}} on target',
      subtitleAllOnTarget_one: "{{count}} KPI on target",
      subtitleAllOnTarget_other: "All {{count}} KPIs on target",
      asOfSuffix: 'as of {{time}}',
      kpiAllClearAccessibilityLabel_one: "{{count}} KPI on target. Show all.",
      kpiAllClearAccessibilityLabel_other: "All {{count}} KPIs on target. Show all.",
      kpiAllClearText_one: "{{count}} KPI on target",
      kpiAllClearText_other: "All {{count}} KPIs on target",
      showAllLabel: 'Show all',
      hideOnTargetKpis: 'Hide on-target KPIs',
      showOnTargetKpis_one: 'Show {{count}} on-target KPI',
      showOnTargetKpis_other: 'Show {{count}} on-target KPIs',
      conditionEyebrow: 'Condition',
      conditionTitle: 'Which assets are deteriorating?',
      conditionSubtitle: 'Derived from inspections, repairs and maintenance history. Tap an asset for the full evidence.',
      maintenanceEyebrow: 'Maintenance',
      maintenanceTitle: 'Where is maintenance slipping?',
      maintenanceSubtitle: 'Skipped work was decided; missed work was not. They are counted apart.',
      sitesEyebrow: 'Sites',
      sitesTitle: 'Which site needs attention?',
      sitesSubtitle: 'Health by site, worst first. Tap a site to focus the whole dashboard on it.',
      focusOnSiteLabel: 'Focus on {{name}}. Health {{score}} of 100.',
      healthDetail: 'Health {{score}}/100 · {{atRisk}} of {{total}} at risk',
      profileEyebrow: 'Profile completeness',
      profileTitle: 'Assets with missing profile details',
      profileSubtitle:
        'These asset records are missing fields used by checklists, risk calculations, and recommendations.',
      profileRowLabel: '{{needsData}} of {{total}} assets have incomplete profiles. Open the list.',
      profileRowTitle: '{{needsData}} of {{total}} asset profiles are incomplete',
      profileWeak_one: '{{count}} has very little structured detail. Open the list to fill the gaps.',
      profileWeak_other: '{{count}} have very little structured detail. Open the list to fill the gaps.',
      profileOpenList: 'Open the list to review and fill the missing fields.',
      forecastEyebrow: 'Forecast',
      forecastTitle: "What's coming",
      forecastSubtitle:
        'Predicted from certificate expiries, schedules and completion pace — act before it slips.',
      todayEyebrow: 'Today',
      topPrioritiesTitle: 'Top priorities',
      subtitleTechnician: 'Your next jobs, ranked by urgency.',
      subtitleManager: 'Top 5 ranked priorities across your scope, with reasoning and a recommended action.',
      visibleOfTotal: '{{visible}} of {{total}}',
      viewDetailsLabel: 'View details',
      workloadLabel: 'Workload',
      reportingInsightLabel: 'Reporting insight',
      clearedTitle: "You're clear.",
      clearedBody: "No priorities right now — we'll surface new ones as data comes in.",
      riskEyebrow: 'Risk',
      riskTitle: 'Where is risk concentrated?',
      riskSubtitle: 'Ranked exposure across the portfolio, broken down by criticality and failure mode.',
      rankedCount_one: "{{count}} ranked",
      rankedCount_other: "{{count}} ranked",
      topExposuresEyebrow: 'Top condition exposures',
      topExposuresTitle: 'Which assets carry the most exposure?',
      nextAssetCaption: ' Next: {{name}} (health {{score}}/100).',
      riskHeatmapEyebrow: 'Risk heatmap',
      riskHeatmapTitle: 'Criticality × asset type',
      riskHeatmapCaption: 'Darker cells = higher average risk score.',
      riskByCriticalityEyebrow: 'Risk by criticality',
      riskByCriticalityTitle: 'How is risk distributed by criticality tier?',
      riskByCriticalityCaption_one:
        '{{count}} asset at risk · Risk score of 50/100 or higher. Assets below this threshold may still have overdue work.',
      riskByCriticalityCaption_other:
        '{{count}} assets at risk · Risk score of 50/100 or higher. Assets below this threshold may still have overdue work.',
      topFailuresEyebrow: 'Top failure categories',
      topFailuresTitle: 'What is failing most often?',
      topFailuresCaption_one: '{{label}} leads with {{count}} flagged item; investigate root cause.',
      topFailuresCaption_other: '{{label}} leads with {{count}} flagged items; investigate root cause.',
      fewerAnalytics: 'Fewer analytics',
      moreAnalytics: 'More analytics',
      flowEyebrow: 'Flow',
      flowTitle: 'How is work flowing?',
      flowSubtitle: 'Backlog shape and inspection quality over the last 28 days.',
      backlogEyebrow: 'Backlog composition',
      backlogTitle: 'Is the backlog shrinking or growing?',
      backlogCaption: 'Today: {{overdue}} overdue · {{dueSoon}} due soon · {{upcoming}} upcoming.',
      legendOverdue: 'Overdue',
      legendDueIn7d: 'Due in 7d',
      legendUpcoming: 'Upcoming',
      passRateEyebrow: 'Inspection pass rate',
      passRateTitle: 'Are inspections trending pass or fail?',
      passRateCaption: 'Currently {{current}}% (vs {{prev}}% 28d ago — {{arrow}} {{delta}}pts).',
      passRateEmpty: 'Run more inspections to populate the trend.',
      noScheduledTitle: 'No scheduled items yet.',
      noScheduledDescription: 'Once dated jobs and inspections are available, workload trends will appear here.',
      teamsEyebrow: 'Teams & partners',
      teamsTitle: 'How are teams and contractors performing?',
      teamsSubtitle: 'Rankings use your current scope ({{scope}}). Compare teams when scope is All.',
      compareTeamsTitle: 'Compare teams side by side',
      compareTeamsBody:
        'You are viewing {{scope}}. Switch to All to see workload and throughput ranked across every team.',
      switchToAll: 'Switch to All',
      switchScopeAllLabel: 'Switch scope to All to compare teams',
      teamWorkloadEyebrow: 'Team workload',
      teamWorkloadTitle: 'Which teams carry the most open work?',
      teamThroughputEyebrow: 'Team throughput',
      teamThroughputTitle: 'Who closed the most work in 28 days?',
      cycleTimesShown: 'Cycle times shown where completed jobs have start and finish dates.',
      completedCountsCaption: 'Completed counts for the last 28 days in your current scope.',
      openLabel_one: "{{count}} open",
      openLabel_other: "{{count}} open",
      overdueUnassigned: '{{overdue}} overdue · {{unassigned}} unassigned',
      unassignedOnly_one: "{{count}} unassigned",
      unassignedOnly_other: "{{count}} unassigned",
      doneLabel_one: "{{count}} done",
      doneLabel_other: "{{count}} done",
      avgCycleDays: '{{days}}d avg cycle',
      stillOpen_one: "{{count}} still open",
      stillOpen_other: "{{count}} still open",
      contractorPerformanceEyebrow: 'Contractor performance',
      contractorPerformanceTitle: 'How are contractors delivering against each other?',
      overdueOnly_one: "{{count}} overdue",
      overdueOnly_other: "{{count}} overdue",
      doneWindow_one: "{{count}} done (28d)",
      doneWindow_other: "{{count}} done (28d)",
      sentBack_one: "{{count}} sent back",
      sentBack_other: "{{count}} sent back",
      avgCycle: '{{days}}d avg',
      toAnswer: '{{hours}}h to answer',
      declinedOnly_one: "{{count}} declined",
      declinedOnly_other: "{{count}} declined",
      techQualityEyebrow: 'Technician quality',
      techQualityTitle: 'Which technicians need coaching?',
      techQualityCaption_one:
        'Score blends on-time completion minus reopens (0–100). Median {{median}}/100 across {{count}} technician.',
      techQualityCaption_other:
        'Score blends on-time completion minus reopens (0–100). Median {{median}}/100 across {{count}} technicians.',
      technicianFallback: 'Technician',
      needsCoaching: 'Needs coaching',
      starPerformer: 'Star performer',
      onTrack: 'On track',
      slippageEyebrow: 'Slippage',
      slippageTitle: "What's slipping?",
      slippageSubtitle: 'Inspection coverage, compliance lapses, and gaps in your inspection cadence.',
      coverageGapsEyebrow: 'Coverage gaps',
      coverageGapsTitle: 'Which assets need an inspection now?',
      coverageGapsCaptionKnown:
        'Top item: {{label}} ({{days}}d since last inspection). Items are sorted by days × operational impact.',
      coverageGapsCaptionNever:
        'Top item: {{label}} (never inspected). Items are sorted by days × operational impact.',
      neverLabel: 'Never',
      complianceExpirationsEyebrow: 'Compliance expirations',
      complianceExpirationsTitle: 'What lapses in the next 90 days?',
      complianceExpirationsCaption: '{{expired}} already expired, {{expiringSoon}} expiring within 14 days.',
      overdueDays: '{{days}}d overdue',
      daysLeft: '{{days}}d left',
      inspectionDensityEyebrow: 'Inspection density',
      inspectionDensityTitle: 'Where are the cadence gaps?',
      inspectionDensityCaption_one: "{{count}} inspection in the last ~6 months. Empty stretches signal coverage gaps.",
      inspectionDensityCaption_other: "{{count}} inspections in the last ~6 months. Empty stretches signal coverage gaps.",
      activityEyebrow: 'Activity',
      activityTitle: 'What just happened?',
      activitySubtitle: 'Latest inspections and job updates across your scope.',
      whenToday: 'today',
      whenYesterday: 'yesterday',
      whenDaysAgo: '{{days}}d ago',
      severityFooterText:
        "Severity is shown as operational impact (Low → Critical), not dollar values. AssetWRX doesn't manage P&L — cost data belongs in your ERP. When you connect one, $ figures can be added here.",
      askTitle: 'Ask AssetWRX',
      askPlaceholderExecutive: 'e.g. Which sites cost the most last quarter?',
      askPlaceholderTechnician: 'e.g. What jobs are mine today?',
      askPlaceholderManager: 'e.g. Which assets are due for inspection?',
      askButton: 'Ask',
      pageSubtitle: 'See where work is piling up, which assets are at risk, and who is overloaded.',
    },
  },
  title: "Activity",
  viewFeed: "See team activity",
  analyticsTitle: "Insights",
  recommendations: {
    whyPrefix: "Why:",
    failureTitle: "{{asset}} — Health {{score}}/100",
    impactRisk: "Risk",
    actionOpenAsset: "Open asset",
    actionScheduleAction: "Schedule action",
    actionAssignTechnician: "Assign technician",
    thinHistory: "Thin history for this asset — log an inspection to firm up the score.",
    overdueTitle_one: "{{count}} overdue job in your scope",
    overdueTitle_other: "{{count}} overdue jobs in your scope",
    overdueWhy: "Why: due dates passed without completion — backlog is growing.",
    impactOldest: "Oldest",
    oldestValue_one: "{{count}}d overdue",
    oldestValue_other: "{{count}}d overdue",
    actionTriageBacklog: "Triage backlog",
    complianceTitle_one: "{{count}} compliance item expiring in 30 days",
    complianceTitle_other: "{{count}} compliance items expiring in 30 days",
    complianceWhy: "Why: certifications and inspections lapse without action.",
    impactAtRisk: "At risk",
    assetsCount_one: "{{count}} asset",
    assetsCount_other: "{{count}} assets",
    actionOpenCompliance: "Open compliance",
    trainingTitle_one: "{{count}} technician with repeat reopens",
    trainingTitle_other: "{{count}} technicians with repeat reopens",
    trainingWhy: "Why: same asset class reopened multiple times in 90d — likely training gap.",
    impactRecurringRework: "Recurring rework",
    reopensCount_one: "{{count}} reopen",
    reopensCount_other: "{{count}} reopens",
    actionViewContacts: "View contacts",
    inspectionDueTitle_one: "{{count}} asset needs inspection",
    inspectionDueTitle_other: "{{count}} assets need inspection",
    inspectionDueWhy: "Why: no inspection completed in the last 90 days.",
    impactCoverageGap: "Coverage gap",
    actionScheduleInspections: "Schedule inspections",
    approvalsInspections_one: "{{count}} inspection awaiting approval",
    approvalsInspections_other: "{{count}} inspections awaiting approval",
    approvalsJobs_one: "{{count}} job awaiting verification",
    approvalsJobs_other: "{{count}} jobs awaiting verification",
    approvalsTitle_one: "{{count}} decision waiting on you",
    approvalsTitle_other: "{{count}} decisions waiting on you",
    approvalsWhyOne: "Why: {{part}}. Work stays open until someone signs it off.",
    approvalsWhyBoth: "Why: {{first}} and {{second}}. Work stays open until someone signs it off.",
    impactWaiting: "Waiting",
    actionReviewApprove: "Review and approve",
    jobFallback: "Job",
    nextJobDue: "Why: due {{date}}.",
    nextJobAssigned: "Why: assigned to you.",
    impactUrgency: "Urgency",
    actionOpenJob: "Open job",
  },
  insightQuality: {
    confidenceHigh: "High confidence",
    confidenceMedium: "Medium confidence",
    confidenceLow: "Low confidence",
    notEnoughHistory: "{{label}} · not enough recent history",
    basedOnOne: "{{label}} · based on {{part}}",
    basedOnBoth: "{{label}} · based on {{first}} and {{second}}",
    inspections_one: "{{count}} inspection",
    inspections_other: "{{count}} inspections",
    jobs_one: "{{count}} job",
    jobs_other: "{{count}} jobs",
    noInspectionsInScope: "No inspections in scope",
    limitedJobHistory: "Limited job history",
    noCompletedInspections: "No completed inspections",
    noInspectionInDays_one: "No inspection in {{count}} day",
    noInspectionInDays_other: "No inspection in {{count}} days",
    noInspectionHistory: "No inspection history",
    assetMetadataIncomplete: "Asset metadata incomplete",
    noRecentTimestamps: "No recent activity timestamps",
    dataGapNoInspection_one: "Data gap: no inspection in {{count}} day",
    dataGapNoInspection_other: "Data gap: no inspection in {{count}} days",
    dataGapLastActivity_one: "Data gap: last activity {{count}} day ago",
    dataGapLastActivity_other: "Data gap: last activity {{count}} days ago",
    limitedData: "Limited data — treat as directional only",
  },
  activityTimeline: {
    inspectionCompleted: "Inspection completed",
    inspectionInProgress: "Inspection in progress",
    itemsFlagged_one: "{{count}} item flagged",
    itemsFlagged_other: "{{count}} items flagged",
    allPassing: "All items passing",
    jobUpdated: "Job updated",
  },
  portfolioNarrative: {
    flat: "Portfolio health is {{score}}/100 — trends appear as data builds up.",
    improved_one: "Your portfolio is healthier this month — operation health climbed {{count}} point to {{score}}/100{{driver}}.",
    improved_other: "Your portfolio is healthier this month — operation health climbed {{count}} points to {{score}}/100{{driver}}.",
    improvedDriver_one: ", as {{count}} asset moved out of the at-risk band",
    improvedDriver_other: ", as {{count}} assets moved out of the at-risk band",
    slipped_one: "Portfolio health slipped {{count}} point to {{score}}/100 this month.",
    slipped_other: "Portfolio health slipped {{count}} points to {{score}}/100 this month.",
    steady: "Portfolio health held steady at {{score}}/100 this month.",
    concern: " One to watch: {{concern}}.",
  },
  partnersCaptions: {
    teamEmpty: "Assign jobs to teams to compare workload and throughput.",
    teamSingle: "{{team}}: {{open}} open, {{completed}} completed in {{days}}d.",
    teamOverdue: "{{worst}} has the most overdue work ({{overdue}}); {{leader}} carries the largest open queue ({{open}}).",
    teamThroughput: "{{leader}} has the largest open queue; {{top}} closed the most in {{days}}d ({{completed}}).",
    teamLeader_one: "{{leader}} has the largest open queue ({{count}} job).",
    teamLeader_other: "{{leader}} has the largest open queue ({{count}} jobs).",
    contractorEmpty: "Assign contractor-delivered jobs to see performance here.",
    contractorOverdue_one: "{{worst}} has {{count}} overdue job; {{leader}} has the highest active load ({{open}} open).",
    contractorOverdue_other: "{{worst}} has {{count}} overdue jobs; {{leader}} has the highest active load ({{open}} open).",
    contractorRework_one: "{{name}} had {{count}} job sent back; {{leader}} leads open assignments ({{open}}).",
    contractorRework_other: "{{name}} had {{count}} jobs sent back; {{leader}} leads open assignments ({{open}}).",
    contractorCompleted_one: "{{name}} completed {{count}} job in {{days}}d; {{leader}} has {{open}} open.",
    contractorCompleted_other: "{{name}} completed {{count}} jobs in {{days}}d; {{leader}} has {{open}} open.",
    contractorLeader: "{{leader}} has the highest contractor workload ({{open}} open).",
  },
  siteRisk: {
    whyTwoDrivers: "Operational health {{score}}/100 — risk driven by {{first}} and {{second}}.",
    whyOneDriver: "Operational health {{score}}/100 — risk driven by {{driver}}.",
    whyExposure: "Operational health {{score}}/100 — operational exposure {{risk}}/100.",
    subLabelExposure: "Operational exposure {{risk}}/100",
  },
  rootCause: {
    assetCount_one: "{{count}} asset",
    assetCount_other: "{{count}} assets",
    dayCount_one: "{{count}} day",
    dayCount_other: "{{count}} days",
    jobCount_one: "{{count}} job",
    jobCount_other: "{{count}} jobs",
    categoryJobs_one: "{{count}} {{category}} job",
    categoryJobs_other: "{{count}} {{category}} jobs",
    itemFailures_one: "{{count}} “{{label}}” failure",
    itemFailures_other: "{{count}} “{{label}}” failures",
    categoryIssues_one: "{{count}} {{category}} issue",
    categoryIssues_other: "{{count}} {{category}} issues",
    jobReopens_one: "{{count}} job reopen",
    jobReopens_other: "{{count}} job reopens",
    reopenCount_one: "{{count}} reopen",
    reopenCount_other: "{{count}} reopens",
    likelyDriver: "Likely driver: {{driver}}",
    titleJobCategory: "Recurring pattern: {{jobs}} across {{assets}} in {{days}}",
    driverJobCategory: "repeated {{category}} work category across similar assets.",
    driverJobCategoryScope: "Same operational trigger or checklist scope may be under-addressed.",
    counterJobCategory: "Planned maintenance can legitimately repeat the same category — confirm schedules.",
    actionJobCategory: "Review {{category}} work scope, repair method, and inspect related assets.",
    titleInspectionItem: "Recurring pattern: {{failures}} across {{assets}} in {{days}}{{site}}",
    siteSame: " at the same site",
    siteMultiple: " across multiple sites",
    driverInspectionItem: "same inspection item failing repeatedly ({{label}}).",
    driverInspectionItemScope: "Checklist scope, environmental conditions, or repair verification on this item.",
    counterInspectionItem: "Seasonal or one-off inspection campaigns can cluster failures temporarily.",
    actionInspectionItem: "Review checklist item “{{label}}” and inspect related assets on site.",
    titleAssetRepeat: "Recurring pattern: {{asset}} failing again after repair ({{jobs}} in {{days}})",
    driverAssetRepeat: "same failure category recurring after repair.",
    driverAssetRepeatCause: "Repair method, parts, or root defect may not have been resolved.",
    counterAssetRepeat: "Follow-up work may be planned verification — confirm job intent.",
    actionAssetRepeat: "Review repair method and inspect related assets.",
    latestRepair: "Latest repair",
    postRepairInspection: "Post-repair inspection with failures",
    titleFailureType: "Recurring pattern: {{issues}} on {{assetType}} assets ({{assets}}, {{days}})",
    driverFailureType: "{{category}} failures clustering on {{assetType}} asset type.",
    counterFailureType: "Asset type mix may be small — confirm sample is representative.",
    actionFailureType: "Review {{category}} standards for {{assetType}} assets and related checklist items.",
    titleTechReopen: "Recurring pattern: {{reopens}} linked to {{name}} in {{days}}",
    driverTechReopen_one: "{{name}} associated with repeat reopens on {{count}} category.",
    driverTechReopen_other: "{{name}} associated with repeat reopens on {{count}} categories.",
    driverTechReopenCause: "Closure criteria, parts, or handoff quality may need review.",
    counterTechReopen: "Reopens can reflect customer callbacks unrelated to technician skill.",
    actionTechReopen: "Review reopened jobs with {{name}} and verify closure criteria.",
    titleVendorReopen: "Recurring pattern: {{reopens}} with vendor {{name}} in {{days}}",
    driverVendor: "contractor {{name}} linked to repeat reopens.",
    counterVendor: "Vendor workload spikes can correlate with reopens without quality issues.",
    actionVendor: "Review contractor performance and scope for {{name}}.",
    titlePart: "Recurring pattern: {{jobs}} involving “{{part}}” across {{assets}} in {{days}}",
    driverPart: "part or category “{{part}}” associated with repeat jobs.",
    counterPart: "Stocking or PM kits can legitimately repeat the same part across assets.",
    actionPart: "Review part quality, fit, and PM scope for “{{part}}”.",
    assetFallback: "Asset",
    jobFallback: "Job",
    contractorFallback: "Contractor",
    checklistItemFallback: "Checklist item",
    uncategorised: "Uncategorised",
    impactRecurrence: "Recurrence",
    impactRecurrenceValue_one: "{{events}} in {{count}}d",
    impactRecurrenceValue_other: "{{events}} in {{count}}d",
    reviewPattern: "Review pattern",
    viewJobs: "View jobs",
  },
  actionPlans: {
    reviewData: "Review data",
    reviewDataDetail: "Confirm inspection and job history before committing resources.",
    withinDays_one: "Within {{count}} day",
    withinDays_other: "Within {{count}} days",
    scheduleWithin_one: "Schedule inspection within {{count}} day",
    scheduleWithin_other: "Schedule inspection within {{count}} days",
    scheduleWithinDetail: "Verify condition and capture evidence on site.",
    openAssetRecord: "Open asset record",
    openAssetRecordDetail: "Review history, linked jobs, and last inspection outcomes.",
    scheduleInspection: "Schedule inspection",
    benefitDowntime: "Reduce downtime risk",
    benefitCatchDefects: "Catch defects before failure",
    effortFailureUrgent: "Low — assign technician and inspect seal condition",
    effortFailure: "Low — assign owner and confirm checklist scope",
    triageOverdue: "Triage overdue jobs today",
    triageOverdueDetail: "Reprioritize, reassign, or update due dates.",
    escalateBlockers: "Escalate blockers",
    escalateBlockersDetail: "Surface jobs waiting on parts, access, or approvals.",
    today: "Today",
    benefitSla: "Restore SLA and reduce backlog growth",
    effortOverdue: "Medium — review assignees and due dates across the cluster",
    renewCertificate: "Renew certificate before expiry",
    renewCertificateDetail: "Book certification or compliance inspection before lapse.",
    openCompliance: "Open compliance workspace",
    openComplianceDetail: "Confirm owners and renewal dates per asset.",
    beforeExpiry: "Before expiry (30 days)",
    benefitCompliance: "Avoid compliance lapse and audit exposure",
    effortCompliance: "Low — confirm renewal owner and due dates",
    reviewReopened: "Review reopened jobs and assign coaching",
    reviewReopenedDetail: "Walk through repeat failures with the technician on affected categories.",
    viewContacts: "View contacts",
    viewContactsDetail: "Check workload and pairing for corrective follow-up.",
    thisWeek: "This week",
    benefitRework: "Reduce repeat rework and improve first-time fix rate",
    effortTraining: "Medium — coach on category patterns and verify closure criteria",
    createJob: "Create job",
    scheduleOverdue: "Schedule inspections for overdue assets",
    scheduleOverdueDetail: "Close the 90-day coverage gap with templated checklists.",
    openInspections: "Open inspections workspace",
    openInspectionsDetail: "Batch-schedule or start from the inspections hub.",
    benefitCoverage: "Restore inspection coverage and risk visibility",
    effortInspection: "Low — pick checklist and assign inspectors",
    reviewPattern: "Review recurring pattern",
    inspectRelated: "Inspect related assets",
    inspectRelatedDetail: "Walk the cluster assets and verify repair method, parts, and checklist scope.",
    reviewSupporting: "Review supporting jobs and inspections",
    reviewSupportingDetail: "Confirm evidence before changing standards.",
    patternWindow: "Pattern · {{value}}",
    benefitCycles: "Break repeat-failure cycles and reduce rework",
    effortRootCause: "Medium — cross-check jobs, inspections, and repair history",
    viewJobs: "View jobs",
    startAssignedJob: "Open and start assigned job",
    dueWindow: "Due · {{value}}",
    whenDue: "When due",
    benefitOnTrack: "Keep assigned work on track",
    effortNextJob: "Low — open job and post first update",
    openJob: "Open job",
  },
} as const;
